var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPeriodicTaskIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.33333 14.3333C1.96667 14.3333 1.65278 14.2028 1.39167 13.9417C1.13056 13.6806 1 13.3667 1 13V3.66667C1 3.3 1.13056 2.98611 1.39167 2.725C1.65278 2.46389 1.96667 2.33333 2.33333 2.33333H3V1H4.33333V2.33333H9.66667V1H11V2.33333H11.6667C12.0333 2.33333 12.3472 2.46389 12.6083 2.725C12.8694 2.98611 13 3.3 13 3.66667V7.66667H11.6667V6.33333H2.33333V13H7V14.3333H2.33333ZM11.6667 15.6667C10.8556 15.6667 10.1472 15.4139 9.54167 14.9083C8.93611 14.4028 8.55556 13.7667 8.4 13H9.43333C9.57778 13.4889 9.85278 13.8889 10.2583 14.2C10.6639 14.5111 11.1333 14.6667 11.6667 14.6667C12.3111 14.6667 12.8611 14.4389 13.3167 13.9833C13.7722 13.5278 14 12.9778 14 12.3333C14 11.6889 13.7722 11.1389 13.3167 10.6833C12.8611 10.2278 12.3111 10 11.6667 10C11.3444 10 11.0444 10.0583 10.7667 10.175C10.4889 10.2917 10.2444 10.4556 10.0333 10.6667H11V11.6667H8.33333V9H9.33333V9.95C9.63333 9.66111 9.98333 9.43056 10.3833 9.25833C10.7833 9.08611 11.2111 9 11.6667 9C12.5889 9 13.375 9.325 14.025 9.975C14.675 10.625 15 11.4111 15 12.3333C15 13.2556 14.675 14.0417 14.025 14.6917C13.375 15.3417 12.5889 15.6667 11.6667 15.6667ZM2.33333 5H11.6667V3.66667H2.33333V5Z",
    fill: "#262626"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeriodicTaskIcon);
export default __webpack_public_path__ + "static/media/periodicTaskIcon.4ebf9dd5866daeed17272b81038658f6.svg";
export { ForwardRef as ReactComponent };